<template>
  <AuModal
    v-model="showModal"
    width="480px"
    padding="15px 20px 26px 20px"
  >
    <template #header>
      <div class="header-popup" />
    </template>
    <template #body>
      <div class="title-popup flex justify-content-center">
        {{ $t("popUp.title") }}
      </div>
      <div class="flex justify-content-center">
        {{ $t("popUp.message", {defaultCurrency}) }}
      </div>
    </template>
    <template #footer>
      <div class="footer-popup flex justify-content-between">
        <AuButton
          width="200px"
          center
          @click="showModal=false"
        >
          {{ $t("popUp.cancelBtn") }}
        </AuButton>
        <AuButton
          type="primary"
          width="200px"
          center
          @click="goToDeposit"
        >
          {{ $t("popUp.depositBtn", {defaultCurrency}) }}
        </AuButton>
      </div>
    </template>
  </AuModal>
</template>

<script setup>

import AuButton from "@/components/extended/AuButton.vue";
import localStorageController from "@/help/localStorageController";
import { checkAccess, scope } from "@/help/accessData";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const router = useRouter();
const store = useStore();
const showModal = ref(false);

const showPopUp = () => {
  localStorageController.setPopUpDate(new Date());
  showModal.value = true;
};
const goToDeposit = () => {
  if (!isNotRwa.value) {
    router.push({ name: "card buy form" });
  }
  else {
    router.push({ name: "buy form" });
  }
};

const isNotRwa = computed(() => {
  return checkAccess(scope.notRwa);
});

const defaultCurrency = computed(() => {
  return process.env.VUE_APP_CURRENCY_DEFAULT;
});

onMounted(async () => {
  await store.dispatch("getAuOwners");
  if (store.getters.auOwners.length > 0) {
    return;
  }
  const lastShowDate = Date.parse(localStorageController.getPopUpDate());
  if (!lastShowDate) {
    showPopUp();
    return;
  }
  if (new Date() - lastShowDate > (60 * 60 * 24 * 1000)) {
    showPopUp();
  }
});

</script>

<style scoped lang="scss">
.header-popup {
  height: 20px;
}
.title-popup {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
}
.footer-popup {
  margin-top: 20px;
}
</style>